<template>
  <div class="Menu">

    <router-link class="Menu-item"
      v-for="(item, index) in items"
      :class="`Menu-item--${item.name}`"
      key="index"
      v-if="suite.id"
      :style="menuItemStyle(item, index)"
      :to="{ name: item.name }">

      <div class="Menu-itemContent">

        <div class="Menu-itemLabel"
          :style="{ top: `${item.offsetY}px` }">

          <div class="Menu-itemSupertitle"
            v-if="item.supertitle"
            v-html="item.supertitle">
          </div>

          <div class="Menu-itemTitle"
            v-if="item.title"
            v-html="item.title">
          </div>

          <icon class="Menu-itemIcon"
            v-if="item.icon"
            :name="item.icon" />

        </div>

      </div>

    </router-link>

  </div>
</template>

<script>
import Icon from 'components/Icon'

export default {
  name: 'Menu',

  components: {
    Icon
  },

  computed: {
    suite () { return this.$store.state.suite },
    animal () { return this.$store.state.animal },
    recentlyAdopted () { return this.$store.state.recentlyAdopted },
    suiteIsUnoccupied () { return this.$store.state.suiteIsUnoccupied },

    items () {
      const items = []

      // Add Learn button
      if (this.animal.surveys && this.animal.surveys.length > 0) {
        items.push({
          title: 'Learn',
          name: 'learn',
          position: 25
        })
      }

      // Add The Bond section
      if (this.suite.story && this.suite.story.length > 0) {
        items.push({
          supertitle: 'The',
          title: 'Bond',
          name: 'the-bond',
          position: 328
        })
      }

      // Add other sections
      items.push({
        title: 'About',
        name: 'about',
        position: 197
      })

      items.push({
        title: 'Adopt',
        name: 'adopt',
        position: 212
      })

      items.push({
        supertitle: 'Notify Me',
        name: 'share',
        position: 155,
        icon: 'plus'
      })

      return items
    }
  },

  methods: {
    /**
     * Return style object with item location on perimeter of circle
     * @param  {Object} item
     * @param  {Integer} index
     * @return {Object}
     */
    menuItemStyle (item, index) {
      return {
        // Spread items around perimeter of circle
        transform: `rotate(${item.position}deg) translateX(${(item.offset ? item.offset : '465.36')}px) rotate(-${item.position}deg)`
      }
    }
  }
}
</script>

<style>
.Menu {
  position: absolute;
  z-index: 900;
  top: 50%;
  left: 50%;
}

.Menu-item {
  position: absolute;
  z-index: 100;
  top: 0;
  left: 0;
  display: block;
  text-decoration: none;
  top: -48.636px;
  left: -48.636px;
  width: 97.272px;
  height: 97.272px;
}

/*.Menu-item--adopt,*/
/*.Menu-item--adopt > .Menu-itemContent {*/
/*  width: 130px;*/
/*  height: 130px;*/
/*}*/

/*.Menu-item--adopt > .Menu-itemContent > .Menu-itemLabel > .Menu-itemTitle {*/
/*  font-size: 25.25px;*/
/*}*/

.Menu-itemContent {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 97.272px;
  height: 97.272px;
  border-radius: 50%;
  border: 2px solid var(--color-1);
  background-color: var(--color-3);
  color: var(--color-1);
  -webkit-font-smoothing: antialiased;
}

.Menu-item.router-link-active .Menu-itemContent {
  background-color: var(--color-1);
  border-color: var(--color-3);
  color: var(--color-3);
}

.Menu-itemLabel {
  position: relative;
}

.Menu-itemSupertitle {
  font-size: 10px;
  line-height: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  text-align: center;
}

.Menu-item--adopted .Menu-itemSupertitle {
  /*position: relative;*/
  /*top: 3px;*/
}

.Menu-itemTitle {
  font-size: 19px;
  line-height: 16.77px;
  font-weight: 500;
  text-align: center;
}

.Menu-itemIcon {
  margin: 6px auto 0;
  width: 18px;
  height: 18px;
}

.Menu-itemIcon svg {
  position: relative;
  fill: var(--color-1);
}

.Menu-item.router-link-active .Menu-itemIcon svg {
  fill: var(--color-3) !important;
}
</style>



// WEBPACK FOOTER //
// Menu.vue?686418dc